import React, { memo, useState } from "react";
import "./index.css";

const Option = () => {
  const [secondOption, setSecondOption] = useState(false);
  return (
    <>
      <div className="content d-flex justify-content-center">
        {!secondOption && (
          <div className="d-grid" style={{ width: "200px" }}>
            <button
              className="btn bg-primary border mb-3"
              style={{ minHeight: "70px", fontSize: "30px" }}
              onClick={() => {
                setSecondOption(true);
              }}
            >
              BCA
            </button>
            <button
              className="btn bg-primary border mb-3"
              style={{ minHeight: "70px", fontSize: "30px" }}
            >
              Access
            </button>
            <button
              className="btn bg-primary border"
              style={{ minHeight: "70px", fontSize: "30px" }}
            >
              Fire
            </button>
          </div>
        )}
        {secondOption && (
          <div className="d-grid" style={{ width: "600px" }}>
            <button
              className="btn bg-primary border mb-3"
              style={{ minHeight: "70px", fontSize: "30px" }}
              onClick={() => {
                window.location.href = "/step1";
              }}
            >
              BCA Report
            </button>
            <button
              className="btn bg-primary border mb-3"
              style={{ minHeight: "70px", fontSize: "30px" }}
            >
              BCA Performance Solution Report
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default memo(Option);
